<div class="activeUser">
  <div class="header-div d-flex align-items-center">
    <div class="d-flex align-items-center">
      <div class="logo-div">
        <img src="/assets/images/Piqet_NewLogo.svg" alt="Logo" />
      </div>
      <div class="go-back-div" routerLink="/register">
        <i class="bi bi-arrow-left"></i>
        <span>Go back</span>
      </div>
    </div>
  </div>
  <div class="text-center mb-5 mt-5">
    <p class="text-dark p-0 m-0">
      <span class="content-text">Your payment is cancelled please try again.</span>
    </p>
  </div>
  <div class="text-center mb-3">
    <a class="linkText" routerLink="/login"> Login here</a>
  </div>
  <div class="copyright">
    <a class="linkText" href="http://www.lifecycles.com.au/" target="_blank"
      >© Life Cycle Strategies Pty Ltd</a
    >
  </div>
</div>
